export default "__VITE_ASSET__r7AT9ecu__"